// Generated by ReScript, PLEASE EDIT WITH CARE

import * as AssetStore$PorterinFeature from "../../../../ui/assets/AssetStore.mjs";
import * as PnMStoreEn$PorterinFeature from "../../domain/store/PnMStoreEn.mjs";

var calenderIcon = {
  src: PnMStoreEn$PorterinFeature.calenderIcon,
  width: 18.0,
  height: 18.0,
  alt: PnMStoreEn$PorterinFeature.calenderIconAlt
};

var calenderIconV2 = {
  path: PnMStoreEn$PorterinFeature.calenderIcon,
  alt_text: PnMStoreEn$PorterinFeature.calenderIconAlt
};

var phoneIcon = {
  path: PnMStoreEn$PorterinFeature.phoneIcon,
  alt_text: PnMStoreEn$PorterinFeature.phoneIconAlt
};

var houseSizeIcon = {
  src: PnMStoreEn$PorterinFeature.houseSizeIcon,
  width: 18.0,
  height: 18.0,
  alt: PnMStoreEn$PorterinFeature.houseSizeIconAlt
};

var houseSizeIconV2 = {
  path: PnMStoreEn$PorterinFeature.houseSizeIcon,
  alt_text: PnMStoreEn$PorterinFeature.houseSizeIconAlt
};

var accordionIcon = {
  src: PnMStoreEn$PorterinFeature.accordianIcon,
  width: 18.0,
  height: 18.0,
  alt: PnMStoreEn$PorterinFeature.accordianIconAlt
};

var clearInputIcon = {
  src: AssetStore$PorterinFeature.clearCircularIcon,
  width: 20.0,
  height: 20.0,
  alt: "Clear Input Icon"
};

export {
  calenderIcon ,
  calenderIconV2 ,
  phoneIcon ,
  houseSizeIcon ,
  houseSizeIconV2 ,
  accordionIcon ,
  clearInputIcon ,
}
/* No side effect */
